import React, {useEffect, useRef, useState} from "react";
import {useHistory} from "react-router-dom";
import './sections.scss'
import {ConvertToJalali, RewardsData} from "../../StoreDetail/StoreDetailServices";
import SwiperId from "react-id-swiper";
import SimpleLineIcon from "react-simple-line-icons";
import {MenuCats, MenuData} from "../HomeServices";
import Swiper from "react-id-swiper";
import Skeleton from "react-loading-skeleton";
import {AllMenuData} from "../../Menu/MenuServices";



const MenuList = ({item}) =>{
    const [catt,set_cats] = useState([]);
    const [mainCat,set_mainCat] = useState([]);
    const CatRef = useRef(null);
    const history = useHistory();
    const [currentC,setCurrentC] = useState("");

    const params = {
        slidesPerView: 4,
        spaceBetween: 0,
        rtl:true,
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        }
    }

    const setMenuItem = (merchantId,cat,status) =>{
        history.push(`/menu/${merchantId}`,{item:{merchantId,cat,status}})
    }



    const updateSlider = () =>{
        CatRef.current.swiper.update();
    }

    const getMenu = async () => {
        console.log("ITEM DATA : ",item)
        try{
            const response = await AllMenuData(item.items[0].link_to_uid)
            const menu = response.data;

            let cats = [];
            set_mainCat(response.data)
            menu.forEach(root=>{
                root.childes.forEach(cat=>{
                    cat['parent']={uid:root.uid}
                    cats.push(cat)
                })
            })
            console.log("CATS : ",cats)
            set_cats(cats)
            updateSlider()


            // if(respo.data.length>0){
            //     const cats = await MenuCats(item.items[0].link_to_uid,respo.data[0].uid)
            //     set_cats(cats.data)
            //     updateSlider()
            // }
        }catch (e) {
            console.log(e)
        }
    }

    const getAllCat = () => {}
    const CatClick = (cat) => {
        setMenuItem(item.items[0].link_to_uid,cat,"cat")
    }
    const AllClick = (cat) => {
        console.log("CAT : ",cat)
        console.log("CATTTT : ",catt)
        setMenuItem(item.items[0].link_to_uid,catt[1],"all")
    }

    const rootClick = (cat) => {
        console.log("Item : ",cat)
        setMenuItem(item.items[0].link_to_uid,cat,"root")
    }

    useEffect(()=>{
        getMenu()
    },[])

    return(
        <div className="c-tabs cats-swiper" >
            <div className="menu-cats-subject">
                {catt.length>0?<span>لیست محصولات / خدمات</span>:null}
            </div>
            { catt? <Swiper  ref={CatRef}  {...params} >
                {/*<div className="cats_menu" onClick={()=>AllClick()}>*/}
                {/*    <img*/}
                {/*        className={currentC.uid==='0'?"active":""}*/}
                {/*        src={"/other/merchant_logo.png"} alt=""/>*/}
                {/*    <span className="menu-cats-name">{"همه"}</span>*/}
                {/*</div>*/}



                {catt.map(cat=>{
                    return(
                        <div className="cats_menu" style={{margin:3}} onClick={()=>CatClick(cat)}>
                        {cat.img?
                            <img src={cat.image} alt=""  className={currentC.uid===cat.uid?"active":""}/>:
                            <img src={cat.image} alt=""  className={currentC.uid===cat.uid?"active":""}/>
                        }
                        <span className="menu-cats-name"> {cat.name}</span>
                    </div>
                    )
                })}


                {/*{mainCat.map(cat=>{*/}
                {/*    return(*/}
                {/*        <div className="cats_menu" style={{margin:3}} onClick={()=>rootClick(cat)}>*/}
                {/*            {cat.img?*/}
                {/*                <img src={cat.image} alt=""  className={currentC.uid===cat.uid?"active":""}/>:*/}
                {/*                <img src={cat.image} alt=""  className={currentC.uid===cat.uid?"active":""}/>*/}
                {/*            }*/}
                {/*            <span className="menu-cats-name"> {cat.name}</span>*/}
                {/*        </div>*/}
                {/*    )*/}
                {/*})}*/}


                        {/*<div>*/}
                        {/*    <div className="cats_menu"  onClick={()=>getAllCat()}>*/}
                        {/*        <img*/}
                        {/*            className={currentC.uid==='0'?"active":""}*/}
                        {/*            src={"/other/merchant_logo.png"} alt=""/>*/}
                        {/*        {"همه"}*/}
                        {/*    </div>*/}
                        {/*    {catt.map(cat=>{*/}
                        {/*        return(*/}
                        {/*            <div className="cats_menu" onClick={()=>CatClick(cat)}>*/}
                        {/*                {cat.img?*/}
                        {/*
                                   <img src={cat.image} alt=""  className={currentC.uid===cat.uid?"active":""}/>:*/}
                        {/*                    <img src={cat.image} alt=""  className={currentC.uid===cat.uid?"active":""}/>*/}
                        {/*                }*/}
                        {/*                {cat.name}*/}
                        {/*            </div>*/}
                        {/*        )*/}
                        {/*    })}*/}

                        {/*</div>*/}
            </Swiper>:null}
        </div>
    )
}

export {MenuList}
